module.exports = __webpack_public_path__ + "static/img/11.d27ef158.png";